var RimSearchComponentJS = (function ($) {

    var searchFormSel = '#searchForm';
    var searchFieldSel = '.j-sf-input-rim';
    var resultsMessageSel = '.j-results-message';
    var productTypeUrl = $('#j-productType').val() || "";

    var priorityFacets = ['width', 'profile', 'constructionType','size'];

    var init = function () {
        $(searchFieldSel).on('change', function () {
            var $this = $(this);
            var searchForm = createJSONObject($this);
            var extraParams = {};
            extraParams.contentType = "application/json; charset=utf-8";
            MainJS.untrackedAjaxCall(ACC.config.contextPath + productTypeUrl + "/rims/search/reload/facets", "POST", JSON.stringify(searchForm), function (data) {
                handleSuccess(data, searchForm);
            }, function(xhr, status, error) {
                console.log("Ajax: Error" + error);
            }, extraParams);
        });
    };

    var createJSONObject = function (chObj) {
        var filterJSONObject = {};
        filterJSONObject.initiatorIndex = chObj.data('index-no');
        filterJSONObject.initiatorName = chObj.data('facet-name');
        filterJSONObject.initiatorValue = chObj.val();

        if (chObj.attr('type') === 'checkbox') {
            filterJSONObject.initiatorValue = chObj.is(":checked");
        } else {
            filterJSONObject.initiatorValue = chObj.val();
        }

        $('select' + searchFieldSel + ' option:selected', $(searchFormSel)).each(function () {
            handleSelectFilterJSONObject(filterJSONObject, this);
        });

        $('select' + searchFieldSel + ' option:selected', $('#facetsidebar')).each(function () {
            handleSerpFilters(this);
        });

        $('input[type=checkbox]' + searchFieldSel, $(searchFormSel)).each(function () {
            var $this = $(this);
            var facetName = $this.data('facet-name');
            if (facetName === 'season') {
                if ($this.is(":checked")) {
                    filterJSONObject[facetName] = $this.val();
                }
            } else {
                filterJSONObject[facetName] = $this.is(":checked");
            }
        });

        $('input[type=text]' + searchFieldSel, $(searchFormSel)).each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                filterJSONObject[$this.data('facet-name')] = $this.val();
            }
        });

        $('input[type=hidden]' + searchFieldSel, $(searchFormSel)).each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                var thisName = $this.data('facet-name');

                if (thisName.indexOf('[') > -1) {
                    handleHiddenArray(filterJSONObject, $this);
                } else {
                    filterJSONObject[thisName + 'Hidden'] = true;
                    filterJSONObject[thisName] = $this.val();
                }
            }
        });

        return filterJSONObject;
    };

    var handleSelectFilterJSONObject = function (filterJSONObject, element) {
        var $this = $(element);
        var facetName = $this.parent().data('facet-name');
        var value = $this.val();

        if (value !== '') {
            if (facetName == "brand") {
                value = [value];
            }
            if (filterJSONObject["season"] == "sogan" && facetName == "studded") {
                filterJSONObject[facetName] = "";
            } else if (facetName == "toEt" && isLessThan(value, "[data-facet-name=fromEt]")) {
                $this.parent().val("");
                filterJSONObject[facetName] = "";
            } else if (facetName == "toDia" && isLessThan(value, "[data-facet-name=fromDia]")) {
                $this.parent().val("");
                filterJSONObject[facetName] = "";
            } else {
                filterJSONObject[facetName] = value;
            }
        }
    };

    var handleSerpFilters = function (element) {
        var $this = $(element);
        var value = $this.val();
        var facetName = $this.parent().attr('name');
        if (facetName == "toEt" && isLessThan(value, "[name=fromEt]")) {
            $this.parent().val("");
        } else if (facetName == "toDia" && isLessThan(value, "[name=fromDia]")) {
            $this.parent().val("");
        }
    }

    var handleHiddenArray = function (filterJSONObject, elem) {
        var thisName = elem.data('facet-name');
        var thisNameStripped = thisName.substr(0, thisName.indexOf('['));

        if (filterJSONObject[thisNameStripped] === undefined) {
            filterJSONObject[thisNameStripped] = [elem.val()];
        } else {
            var prevValue = filterJSONObject[thisNameStripped];
            filterJSONObject[thisNameStripped][prevValue.length] = elem.val();
        }
    };

    var facetsContainFacetName = function (facets, facetCode) {
        var containsIndex = -1;
        $.each(facets, function (fi, facet) {
            if (facet.code === facetCode) {
                containsIndex = fi;
                return false; //exit $.each iteration
            }
        });

        return containsIndex;
    };

    var handleSuccess = function (data, requestObject) {
        handleResultsAttributes(data.pagination.totalNumberOfResults, data.lastFacet);
        $('[data-facet-name=' + requestObject.initiatorName + '] option[fa=true]').remove();// remove previous added options that do not lead to results
        var initiatorIndex = parseInt(requestObject.initiatorIndex);
        var initiatorElementObj = $('[data-index-no=' + requestObject.initiatorIndex + ']');

        $('[data-index-no]').filter(function(){return $(this).data("index-no") > initiatorIndex}).each(function () {
            var $formEl = $(this);
            var containsIndex = facetsContainFacetName(data.facets, $formEl.data('facet-name'));
            var facetName = $formEl.data('facet-name');

            if (facetName == 'width' || facetName == 'profile' || facetName == 'size') {
                var allText = ACC.optionAllSizes;
            } else {
                var allText = ACC.optionAll;
            }
            var all = "<option value=''>" + allText + "</option>";
            var allSelected = "<option value='' selected='selected'>" + allText + "</option>";

            if (containsIndex > -1) {
                var facet = data.facets[containsIndex];

                switch ($formEl.prop('tagName')) {
                    case "SELECT" : {

                        var $prevSelectedOption = $formEl.find('option:selected');
                        var selectedOptionVal = $prevSelectedOption.val();
                        var $prevSelectedOptionAdded = false;
                        var facetHadSelectedOption = false;

                        var isWidthFacet = $formEl.data('facet-name') === 'width';
                        var isProfileFacet = $formEl.data('facet-name') === 'profile';
                        var isSizeFacet = $formEl.data('facet-name') === 'size';
                        var isToEt = $formEl.data('facet-name') === 'toEt';
                        var isToDia = $formEl.data('facet-name') === 'toDia';

                        $('option', $formEl).remove();

                        var newSelectOptions = "";
                        $.each(facet.values, function (fvi, fValue) {
                            newSelectOptions += "<option value='" + fValue.name + "' ";
                            if (fValue.selected === true) {
                                newSelectOptions += "selected='selected'";
                                facetHadSelectedOption = true;
                            }

                            if (selectedOptionVal === fValue.name) {
                                newSelectOptions += "selected='selected'";
                                $prevSelectedOptionAdded = true;
                            }

                            if (isToEt) {
                                newSelectOptions += disableIfLess(fValue.name, '[data-facet-name=fromEt]') + ">" + fValue.displayName + "</option>";
                            } else if (isToDia) {
                                newSelectOptions += disableIfLess(fValue.name, '[data-facet-name=fromDia]') + ">" + fValue.displayName + "</option>";
                            }  else {
                                newSelectOptions += ">" + fValue.displayName + "</option>";
                            }
                        });

                        $formEl.append(newSelectOptions);

                        if ((isProfileFacet || isSizeFacet) && (!facetHadSelectedOption && !$prevSelectedOptionAdded)) {
                            $formEl.prepend(allSelected);
                            facetHadSelectedOption = true;
                        } else if (!$prevSelectedOptionAdded && !facetHadSelectedOption) {
                            if ($prevSelectedOption.val() !== '') {
                                $prevSelectedOption.attr('fa', true);
                            }
                            $formEl.prepend($prevSelectedOption.prop('selected', true));
                        }

                        var allExists = $("option[value='']", $formEl).length > 0;
                        if (!isWidthFacet && !allExists) {
                            $formEl.prepend(all);
                        }

                        break;
                    }
                    case "INPUT" : {
                        break;
                    }
                }
            } else {
                var facetName = $formEl.data('facet-name');
                if (facetName === priorityFacets[0] || facetName === priorityFacets[1] || facetName === priorityFacets[2] || facetName === priorityFacets[3]) {
                    $('option', $formEl).remove();
                    $formEl.append(all);
                } else {
                    var $prevSelected = $('option:selected', $formEl);
                    $('option', $formEl).remove();
                    $formEl.append($prevSelected);
                }
            }
        });
        facetUpdatedNotify(data, requestObject);
    };

    var isLessThan = function(value, fieldSel) {
        var compField = $(fieldSel).val();
        if (parseFloat(value) < parseFloat(compField)) {
            return true;
        }
    }

    var disableIfLess = function(value, fieldSel) {
        if (isLessThan(value, fieldSel)) {
            return "disabled";
        }
    }

    var handleResultsAttributes = function (resultsNumber, lastFacet) {
        $(resultsMessageSel).html(ACC.searchResultsNumberProvide + ' ' + resultsNumber + ' ' + ACC.searchResultsNumberResults);
        if (resultsNumber === 0) {
            $('#searchForm input[type=submit]').prop('disabled', true);
            suggestFacetChange(lastFacet);
        } else {
            $('#searchForm input[type=submit]').prop('disabled', false);
        }
    };

    var suggestFacetChange = function (lastFacet) {
        if (lastFacet) {
            var message = ACC.getParametrizedString(getSuggestionText(resultsMessageSel), lastFacet, "<a class='j-search-by-car'>", "</a>");
            $(resultsMessageSel).html(message);

            $(".j-search-by-car").on("click", function() {
                $('ul.nav a[href="#pane2"]').tab('show');
            });
        }
    };

    var getSuggestionText = function (resultsMessageSel) {
        if($(resultsMessageSel).data("by-car-available") == 'true') {
            return ACC.searchResultsNumberNoResults + ACC.suggestSearchByCar;
        } else {
            return ACC.searchResultsNumberNoResults;
        }
    };

    var facetUpdatedNotify = function (data, requestObject) {
        $(window).trigger("search:facetsUpdated", [data, requestObject]);
    }

    return {
        init : init
    };

})(jQuery);

$(document).ready(function () {
    RimSearchComponentJS.init();
});
